import PropTypes from 'prop-types'
import { AnimatePresence, motion } from 'framer-motion'

import Group from 'components/charts/Group'

export default function Grid({
  top,
  left,
  width,
  height,
  numTicksRow,
  numTicksColumn,
  xScale,
  yScale,
  strokeDasharray,
  strokeWidth,
  stroke
}) {
  const rowTicks = yScale.ticks ? yScale.ticks(numTicksRow) : yScale.domain()
  const columnTicks = xScale.ticks
    ? xScale.ticks(numTicksColumn)
    : xScale.domain()

  const rowYValues = rowTicks.map((d, i) => ({ index: i, y: yScale(d) }))
  const columnXValues = columnTicks.map((d, i) => ({ index: i, x: xScale(d) }))

  return (
    <AnimatePresence initial={false}>
      <Group>
        <Group left={left} top={top}>
          {rowYValues.map(({ y, index }, i) => {
            const prev = rowYValues[i - 1] ?? { y: height }
            return (
              <motion.line
                key={index}
                animate={{
                  y1: y,
                  y2: y
                }}
                initial={{
                  y1: prev.y,
                  y2: prev.y
                }}
                stroke={stroke}
                strokeDasharray={strokeDasharray}
                strokeWidth={strokeWidth}
                transition={{
                  type: 'easeIn',
                  duration: 0.5
                }}
                x1={0}
                x2={width}
              />
            )
          })}
        </Group>
        <Group left={left} top={top}>
          {columnXValues.map(({ x, index }, i) => {
            const prev = columnXValues[i - 1] ?? { x: 0 }
            return (
              <motion.line
                key={index}
                animate={{
                  x1: x,
                  x2: x
                }}
                initial={{ x1: prev.x, x2: prev.x }}
                stroke={stroke}
                strokeDasharray={strokeDasharray}
                strokeWidth={strokeWidth}
                transition={{
                  type: 'easeIn',
                  duration: 0.5
                }}
                y1={0}
                y2={height}
              />
            )
          })}
        </Group>
      </Group>
    </AnimatePresence>
  )
}

Grid.propTypes = {
  top: PropTypes.number,
  left: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  numTicksRow: PropTypes.number,
  numTicksColumn: PropTypes.number,
  xScale: PropTypes.func,
  yScale: PropTypes.func,
  strokeDasharray: PropTypes.string,
  strokeWidth: PropTypes.number,
  stroke: PropTypes.string,
  animate: PropTypes.bool
}
